import React from 'react';
import Icon from '../../../components/AppIcon';

const SystemHealthCard = ({ system }) => {
  const statusConfig = {
    operational: {
      color: 'text-success',
      bgColor: 'bg-success/10',
      icon: 'CheckCircle',
      label: 'Operational'
    },
    degraded: {
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      icon: 'AlertTriangle',
      label: 'Degraded'
    },
    down: {
      color: 'text-error',
      bgColor: 'bg-error/10',
      icon: 'XCircle',
      label: 'Down'
    }
  };

  const config = statusConfig?.[system?.status] || statusConfig?.operational;

  return (
    <div className="flex items-center justify-between py-3 border-b border-border last:border-0">
      <div className="flex items-center gap-3">
        <div className={`w-8 h-8 rounded-lg ${config?.bgColor} flex items-center justify-center`}>
          <Icon name={config?.icon} size={16} className={config?.color} />
        </div>
        <div>
          <p className="text-sm font-medium text-foreground">{system?.name}</p>
          <p className="text-xs text-muted-foreground">{config?.label}</p>
        </div>
      </div>
      <div className="text-right">
        {system?.uptime && (
          <p className="text-sm font-medium text-foreground">{system?.uptime}</p>
        )}
        {system?.responseTime && (
          <p className="text-xs text-muted-foreground">{system?.responseTime}</p>
        )}
        {system?.usage && (
          <p className="text-xs text-muted-foreground">Usage: {system?.usage}</p>
        )}
      </div>
    </div>
  );
};

export default SystemHealthCard;